import { createHttpAction } from '@securitize/ui-components';
import { authoriseWalletNext, GET_WALLETS_NEXT, SAVE_TEMP_AUTH_WALLET_DATA } from './actionTypes';

export const authoriseWallet = (data, options) => createHttpAction(
  authoriseWalletNext,
  { body: { ...data } },
  options,
).action;

export const getWallets = (options) => createHttpAction(
  GET_WALLETS_NEXT,
  options,
).action;

export const saveAuthWallet = (payload) => ({
  type: SAVE_TEMP_AUTH_WALLET_DATA,
  payload,
});
